import React, {Component} from "react";
import ProductosPageBanner from "./productosPageBanner";
import queryString from "query-string";
import {CategoriaProducto} from "../../services/categoriasService";
import {
    ProductosBuscar,
    ProductosPorCategoria,
    CargarTodosLosProductos,
} from "../../services/productosService";
import ProductosPageList from "./productosPageList";
import {ContadorItems} from "../../services/pedidoService";
import {RegistrarEvento} from "../../services/eventosServices";

//function para el lazy

/* function isInViewport(element) {
  var rect = element.getBoundingClientRect();
  var html = document.documentElement;
  var posas = "";
  if (html.clientHeight > rect.top / 3) {
    posas = 1;
  }
  return posas;
}
 */

//function para mostrar las imagenes
function muestraImgs() {
    const sections = document.querySelectorAll(".productosImgAparece");

    for (const section of sections) {
        var src = section.getAttribute("data-src");

        if (section.getBoundingClientRect().top <= window.innerHeight * 1.5) {
            section.src = src;
            section.classList.remove("productosImgAparece");
        }
    }
}

//function que añade los clears cada 5 4  3 y 2 y colorea el menu
function clearsProductos(cat) {
    const existingClears = document.querySelectorAll(".productosClear");
    if (existingClears.length > 0) {
        existingClears.forEach(function (a) {
            a.remove();
        });
    }

    //pintamos la categoria
    var catPuesta = document.getElementById(
        "landingPageCategoriesListItem_" + cat
    );
    if (catPuesta !== null) {
        document.querySelectorAll(".menuElementoP").forEach(function (a) {
            a.classList.remove("menuElementoP");
        });

        catPuesta.classList.add("menuElementoP");
    }
    //

    var productines = document.getElementsByClassName("productos");
    var cuentaProds = 1;
    for (var i = 0; i < productines.length; ++i) {
        var item = productines[i];

        if (cuentaProds % 2 === 0) {
            item.insertAdjacentHTML(
                "afterend",
                '<div class=" productosClear productosClear2"></div>'
            );
        }

        if (cuentaProds % 3 === 0) {
            item.insertAdjacentHTML(
                "afterend",
                '<div class=" productosClear productosClear3"></div>'
            );
        }

        if (cuentaProds % 5 === 0) {
            item.insertAdjacentHTML(
                "afterend",
                '<div class=" productosClear productosClear5"></div>'
            );
        }
        cuentaProds = cuentaProds + 1;
    }
}

function debounce(func, wait) {
    let timeout;
    return function executedFunction(...args) {
        const later = () => {
            clearTimeout(timeout);
            func(...args);
        };
        clearTimeout(timeout);
        timeout = setTimeout(later, wait);
    };
}

const handleScroll = debounce(function () {
    muestraImgs();

    // Scroll spy for subcategories
    const sections = document.querySelectorAll(".subcategoria-section");
    const navLinks = document.querySelectorAll(".subCategoriaLink");
    const headerOffset = 250; // Increased offset to account for header and banner

    let currentSectionId = "";
    sections.forEach((section) => {
        const sectionTop = section.getBoundingClientRect().top + window.pageYOffset - headerOffset;
        if (window.pageYOffset >= sectionTop - 10) {
            currentSectionId = section.getAttribute("id");
        }
    });

    if (sections.length > 0) {
        // If we are above the first section, we still want to highlight the first subcategory
        if (!currentSectionId) {
            currentSectionId = sections[0].getAttribute("id");
        }

        navLinks.forEach((link) => {
            const href = decodeURIComponent(link.getAttribute("href") || "");
            const subNameInId = currentSectionId.replace("subcategoria-", "").replace(/-/g, " ");
            // Match the subcategory name in the URL search param
            const urlMatch = href.match(/[?&]subcategoria=([^&]+)/);
            if (urlMatch && urlMatch[1] === subNameInId) {
                if (!link.classList.contains("subCategoriaLinkP")) {
                    link.classList.add("subCategoriaLinkP");
                }
            } else if (link.classList.contains("subCategoriaLinkP")) {
                link.classList.remove("subCategoriaLinkP");
            }
        });
    }
}, 10);

window.addEventListener("scroll", handleScroll);

class ProductosPage extends Component {
    state = {buscar: "", categoria: {}, productos: [], pedidoContadorItems: 0};
    ultimosParametrosCargados = null;

    async componentDidMount() {
        // Pre-load all products to memory
        CargarTodosLosProductos();

        await this.cargarProductos(this.props);

        muestraImgs();
        clearsProductos();

        if (this.state.pedidoContadorItems === 0 && this.props.onCantidadChanged) {
            try {
                const contadorItems = await ContadorItems();
                this.setState({pedidoContadorItems: contadorItems});
                this.props.onCantidadChanged(0, contadorItems);
            } catch (error) {
                //TODO: Log
                console.log(error);
            }
        }
    }

    handleSearch = (textoBuscar) => {
        this.setState({buscar: textoBuscar, categoria: {}});
    };

    async componentDidUpdate(prevProps) {
        if (prevProps.location.search !== this.props.location.search) {
            await this.cargarProductos(this.props);
        }
    }

    async cargarProductos(props) {
        const parametros = queryString.parse(props.location.search);

        // Si no cambiaron los parámetros de búsqueda/categoría/subcategoría, no necesita recargar
        if (this.ultimosParametrosCargados !== null) {
            if (
                parametros.buscar &&
                this.ultimosParametrosCargados.buscar &&
                parametros.buscar === this.ultimosParametrosCargados.buscar
            )
                return;
            else if (
                parametros.categoria &&
                this.ultimosParametrosCargados.categoria &&
                parametros.categoria === this.ultimosParametrosCargados.categoria &&
                parametros.subcategoria === this.ultimosParametrosCargados.subcategoria
            )
                return;
        }
        this.ultimosParametrosCargados = parametros;

        try {
          
            if (parametros.buscar) {
                const prods = await ProductosBuscar(parametros.buscar);

                this.setState({
                    buscar: parametros.buscar,
                    categoria: {},
                    productos: prods,
                }, () => {
                    muestraImgs();
                    clearsProductos();
                    window.scrollTo(0, 0);
                });

                RegistrarEvento(4, `${parametros.buscar},${prods.length}`, {
                    busqueda: parametros.buscar,
                    resultCount: prods.length,
                });
                return;
            }
            this.setState({buscar: ""});

            if (parametros.categoria) {
                 
                const categoria = await CategoriaProducto(parametros.categoria);
                let productos = await ProductosPorCategoria(categoria.id);

                // Sort products by subcategory if they have subcategories
                if (categoria.subCategorias && categoria.subCategorias.length > 0) {
                    const subCatOrder = {};
                    categoria.subCategorias.forEach((s, index) => {
                        subCatOrder[s.id] = index;
                    });
                    productos.sort((a, b) => {
                        const orderA = subCatOrder[a.idSubCategoria] ?? 999;
                        const orderB = subCatOrder[b.idSubCategoria] ?? 999;
                        if (orderA !== orderB) return orderA - orderB;
                        // Secondary sort by description to keep it consistent
                        return a.descripcion.localeCompare(b.descripcion);
                    });
                }

                if (parametros.subcategoria) {
                    const subcategoria = categoria.subCategorias.find(
                        (s) => s.nombre === parametros.subcategoria
                    );

                    if (subcategoria) {
                        productos = productos.filter(
                            (p) => p.idSubCategoria === subcategoria.id
                        );
                    }
                }
                 
                this.setState({productos: productos, categoria: categoria}, () => {
                    muestraImgs();
                    clearsProductos(categoria.id);
                    window.scrollTo(0, 0);
                });

                return;
            } else this.setState({categoria: {}});
            
            
        } catch (e) {
            //TODO: Mostrar mensaje de error
            //TODO: Log
            console.log(e.response);
        }
    }

    handleCantidadChanged = (nuevaCantidad, totalItemsDelPedido) => {
        if (this.props.onCantidadChanged)
            this.props.onCantidadChanged(nuevaCantidad, totalItemsDelPedido);
        this.setState({pedidoContadorItems: totalItemsDelPedido});
    };

    render() {
        return (
            <div>
                <ProductosPageBanner categoria={this.state.categoria}/>

                {this.state.buscar && this.state.productos.length !== 0 && (
                    <h3>
                        Se encontraron {this.state.productos.length} productos para "
                        {this.state.buscar}"
                    </h3>
                )}

                <div className="cont">
                    <div className="contF">
                        <ProductosPageList
                            productos={this.state.productos}
                            onCantidadChanged={this.handleCantidadChanged}
                            categoria={this.state.categoria}
                            onCategoryChange={(categoria) => this.setState({categoria})}
                        />

                        {this.state.buscar && this.state.productos.length === 0 && (
                            <h3>
                                No se encontraron productos coincidentes para "
                                {this.state.buscar}"
                            </h3>
                        )}
                    </div>
                </div>
            </div>
        );
    }
}

export default ProductosPage;
